import { render, staticRenderFns } from "./app.folder.vue?vue&type=template&id=4b527769&scoped=true&"
import script from "./app.folder.vue?vue&type=script&lang=js&"
export * from "./app.folder.vue?vue&type=script&lang=js&"
import style0 from "./app.folder.vue?vue&type=style&index=0&id=4b527769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b527769",
  null
  
)

export default component.exports